var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pdp-analysis-wrap" },
    [
      _vm.reportData && _vm.isIframe
        ? _c(
            "div",
            {
              staticClass: "header-block-iframe mb-3",
              staticStyle: { position: "sticky", top: "0", "z-index": "100" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "px-4 py-3",
                  staticStyle: { "background-color": "#eff8f5" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-start",
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#209c86",
                              "font-size": "0.75rem",
                              "font-weight": "600",
                              "text-transform": "uppercase",
                              "letter-spacing": "0.05em",
                              "margin-bottom": "0.25rem",
                            },
                          },
                          [_vm._v("\n              PDP Analysis\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "h1",
                          {
                            staticStyle: {
                              color: "#02163b",
                              "font-size": "1.25rem",
                              "font-weight": "700",
                              margin: "0 0 0.25rem 0",
                              "line-height": "1.3",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportData?.product_name) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#6b7280",
                              "font-size": "0.813rem",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "ID: " + _vm._s(_vm.getId(_vm.reportData.url))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isIframe
        ? _c(
            "button",
            {
              staticClass: "back-to-reports-btn mb-3",
              attrs: {
                type: "button",
                onclick:
                  "(function () {\n                  if (window.parent) {\n                      window.parent.dispatchEvent(\n                          new CustomEvent('optix:back-to-dashboard', {\n                              detail: {\n                                  source: 'report-iframe'\n                              }\n                          })\n                      );\n                  }\n              })()",
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [_c("path", { attrs: { d: "M19 12H5M5 12l7-7M5 12l7 7" } })]
              ),
              _vm._v(" "),
              _c("span", [_vm._v("Back to Dashboard")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm.reports.length
        ? _c("section", { staticClass: "urls-section source-sections mt-3" }, [
            _c("div", { staticClass: "space-y-2" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center gap-2" },
                [
                  _vm.selectedReport?.images?.length
                    ? _c(
                        "button",
                        {
                          staticClass: "p-0 border-0 bg-transparent img-thumb",
                          attrs: { type: "button", "aria-label": "Open image" },
                          on: {
                            click: function ($event) {
                              return _vm.openLightbox(
                                _vm.selectedReport.images[0]?.src
                              )
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "img-thumb__img",
                            attrs: {
                              src:
                                _vm.selectedReport.images[0]?.src +
                                "&lightweight=1&scale_width=120",
                              alt: "",
                              width: "40",
                              height: "40",
                              loading: "lazy",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.closeReportDropdown,
                          expression: "closeReportDropdown",
                        },
                      ],
                      staticClass: "report-multiselect",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "report-dropdown-trigger",
                          attrs: { type: "button" },
                          on: { click: _vm.toggleReportDropdown },
                        },
                        [
                          _vm.selectedReport
                            ? _c(
                                "span",
                                {
                                  staticClass: "report-dropdown-trigger__text",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "report-dropdown-trigger__id",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.selectedReport.productId)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "report-dropdown-trigger__sep",
                                    },
                                    [_vm._v("—")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "report-dropdown-trigger__name",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.selectedReport.productName)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.selectedReport
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "report-score-badge bg-success",
                                          attrs: { title: `${_vm.scoreValue}` },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.scoreValue) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "report-dropdown-trigger__placeholder",
                                },
                                [_vm._v("Choose product...")]
                              ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "bi",
                            class: _vm.isReportDropdownOpen
                              ? "bi-chevron-up"
                              : "bi-chevron-down",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isReportDropdownOpen
                        ? _c("div", { staticClass: "report-dropdown-menu" }, [
                            _c(
                              "div",
                              { staticClass: "report-dropdown-search" },
                              [
                                _c("i", {
                                  staticClass:
                                    "bi bi-search report-dropdown-search__icon",
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reportSearchQuery,
                                      expression: "reportSearchQuery",
                                    },
                                  ],
                                  ref: "reportSearchInput",
                                  staticClass: "report-dropdown-search__input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Search by ASIN or name...",
                                  },
                                  domProps: { value: _vm.reportSearchQuery },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.reportSearchQuery =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "report-dropdown-list" },
                              [
                                _vm._l(
                                  _vm.filteredReportList,
                                  function (option) {
                                    return _c(
                                      "li",
                                      {
                                        key: option.id,
                                        staticClass: "report-dropdown-item",
                                        class: {
                                          "is-selected":
                                            _vm.selectedReport &&
                                            _vm.selectedReport.id === option.id,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectReport(option)
                                          },
                                        },
                                      },
                                      [
                                        _vm.selectedReport &&
                                        _vm.selectedReport.id === option.id
                                          ? _c("i", {
                                              staticClass:
                                                "bi bi-check2 report-dropdown-item__check",
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "report-dropdown-item__id",
                                          },
                                          [_vm._v(_vm._s(option.productId))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "report-dropdown-item__name",
                                          },
                                          [_vm._v(_vm._s(option.productName))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "report-dropdown-item__score bg-success",
                                            attrs: {
                                              title: `${option.score ?? 0}`,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(option.score ?? 0) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                !_vm.filteredReportList.length
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "report-dropdown-item report-dropdown-item--empty",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  No products found\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isShared
                    ? _c(
                        "b-dropdown",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            variant: "light",
                            right: "",
                            "no-caret": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("i", {
                                      class: {
                                        "bi bi-sort-alpha-down":
                                          _vm.sortMode === "alpha",
                                        "bi bi-sort-down":
                                          _vm.sortMode === "score_desc",
                                        "bi bi-sort-up":
                                          _vm.sortMode === "score_asc",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1691246855
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.setSortMode("alpha")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-sort-alpha-down me-2",
                              }),
                              _vm._v(
                                "\n              Alphabetical (A → Z)\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.setSortMode("score_desc")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-sort-down me-2" }),
                              _vm._v(
                                "\n              Score (Best → Worst)\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.setSortMode("score_asc")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-sort-up me-2" }),
                              _vm._v(
                                "\n              Score (Worst → Best)\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isShared
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.closeReportHistory,
                              expression: "closeReportHistory",
                            },
                          ],
                          staticClass: "report-history-wrap",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light report-history-btn",
                              attrs: { "aria-label": "History" },
                              on: { click: _vm.toggleReportHistory },
                            },
                            [
                              _c("i", { staticClass: "bi bi-clock-history" }),
                              _vm._v("\n              History\n              "),
                              _vm.historyDateFilter !== "any" ||
                              _vm.historyUserFilter
                                ? _c("span", {
                                    staticClass: "report-history-btn__dot",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "report-history-btn__count" },
                                [_vm._v(_vm._s(_vm.filteredHistoryList.length))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isReportHistoryOpen
                            ? _c(
                                "div",
                                {
                                  staticClass: "report-history-panel",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.closeHistoryDropdowns.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "report-history-panel__header",
                                    },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "report-history-panel__title",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Report History\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "report-history-panel__scope-toggle",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "report-history-panel__scope-btn",
                                              class: {
                                                "is-active":
                                                  _vm.historyScope ===
                                                  "product",
                                              },
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setHistoryScope(
                                                    "product"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    This product\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "report-history-panel__scope-btn",
                                              class: {
                                                "is-active":
                                                  _vm.historyScope === "all",
                                              },
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setHistoryScope(
                                                    "all"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    All\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "report-history-panel__filters",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "report-history-filter",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-calendar3 report-history-filter__icon",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "click-outside",
                                                  rawName: "v-click-outside",
                                                  value: _vm.closeDateDropdown,
                                                  expression:
                                                    "closeDateDropdown",
                                                },
                                              ],
                                              staticClass:
                                                "report-history-filter__select-wrap",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "report-history-filter__select",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.isDateFilterOpen =
                                                        !_vm.isDateFilterOpen
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dateFilterLabel
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "bi bi-chevron-down",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.isDateFilterOpen
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "report-history-filter__dropdown",
                                                    },
                                                    _vm._l(
                                                      _vm.dateFilterOptions,
                                                      function (opt) {
                                                        return _c(
                                                          "li",
                                                          {
                                                            key: opt.value,
                                                            staticClass:
                                                              "report-history-filter__dropdown-item",
                                                            class: {
                                                              "is-selected":
                                                                _vm.historyDateFilter ===
                                                                opt.value,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.setDateFilter(
                                                                  opt.value
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm.historyDateFilter ===
                                                            opt.value
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "bi bi-check2",
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  opt.label
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.historyDateFilter === "specific"
                                            ? _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "click-outside",
                                                      rawName:
                                                        "v-click-outside",
                                                      value:
                                                        _vm.closeDatePicker,
                                                      expression:
                                                        "closeDatePicker",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "report-history-filter__pick-wrap",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-light btn-sm report-history-filter__pick-btn",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.isDatePickerOpen =
                                                            !_vm.isDatePickerOpen
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "bi bi-calendar3",
                                                      }),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.historySpecificDate
                                                              ? _vm.formatHistoryDate(
                                                                  _vm.historySpecificDate
                                                                )
                                                              : "Pick"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.isDatePickerOpen
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "report-history-datepicker",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "report-history-datepicker__header",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "report-history-datepicker__nav",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.datePickerPrevMonth,
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "bi bi-chevron-left",
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "report-history-datepicker__month-label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.datePickerMonthLabel
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "report-history-datepicker__nav",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.datePickerNextMonth,
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "bi bi-chevron-right",
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "report-history-datepicker__weekdays",
                                                            },
                                                            _vm._l(
                                                              [
                                                                "Su",
                                                                "Mo",
                                                                "Tu",
                                                                "We",
                                                                "Th",
                                                                "Fr",
                                                                "Sa",
                                                              ],
                                                              function (d) {
                                                                return _c(
                                                                  "span",
                                                                  { key: d },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(d)
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "report-history-datepicker__days",
                                                            },
                                                            _vm._l(
                                                              _vm.datePickerDays,
                                                              function (
                                                                day,
                                                                idx
                                                              ) {
                                                                return _c(
                                                                  "button",
                                                                  {
                                                                    key: idx,
                                                                    staticClass:
                                                                      "report-history-datepicker__day",
                                                                    class: {
                                                                      "is-other-month":
                                                                        !day.currentMonth,
                                                                      "is-selected":
                                                                        day.isSelected,
                                                                      "is-today":
                                                                        day.isToday,
                                                                      "is-disabled":
                                                                        !day.hasReport,
                                                                    },
                                                                    attrs: {
                                                                      type: "button",
                                                                      disabled:
                                                                        !day.hasReport,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          day.hasReport &&
                                                                            _vm.pickDate(
                                                                              day
                                                                            )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          day.day
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "report-history-filter",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-person report-history-filter__icon",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "click-outside",
                                                  rawName: "v-click-outside",
                                                  value: _vm.closeUserDropdown,
                                                  expression:
                                                    "closeUserDropdown",
                                                },
                                              ],
                                              staticClass:
                                                "report-history-filter__select-wrap",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "report-history-filter__select",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.isUserFilterOpen =
                                                        !_vm.isUserFilterOpen
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.historyUserFilter
                                                          ? _vm.historyUserFilter
                                                          : "All users"
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "bi bi-chevron-down",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.isUserFilterOpen
                                                ? _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "report-history-filter__dropdown",
                                                    },
                                                    [
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "report-history-filter__dropdown-item",
                                                          class: {
                                                            "is-selected":
                                                              !_vm.historyUserFilter,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.setUserFilter(
                                                                null
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          !_vm.historyUserFilter
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "bi bi-check2",
                                                              })
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                        All users\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.historyUserNames,
                                                        function (userName) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: userName,
                                                              staticClass:
                                                                "report-history-filter__dropdown-item",
                                                              class: {
                                                                "is-selected":
                                                                  _vm.historyUserFilter ===
                                                                  userName,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setUserFilter(
                                                                      userName
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm.historyUserFilter ===
                                                              userName
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "bi bi-check2",
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    userName
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.historyDateFilter !== "any" ||
                                          _vm.historyUserFilter
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-link btn-sm text-muted report-history-filter__clear-btn",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click:
                                                      _vm.clearHistoryFilters,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "bi bi-x",
                                                  }),
                                                  _vm._v(
                                                    "\n                    Clear\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "report-history-list" },
                                    [
                                      _vm._l(
                                        _vm.filteredHistoryList,
                                        function (item) {
                                          return _c(
                                            "div",
                                            {
                                              key:
                                                item.id + "-" + item.created_at,
                                              staticClass:
                                                "report-history-list__item",
                                              class: {
                                                "is-active":
                                                  _vm.selectedReport &&
                                                  _vm.selectedReport.id ===
                                                    item.id,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectHistoryReport(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "bi bi-file-earmark-text report-history-list__icon",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "report-history-list__info",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-history-list__name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.getId(item.url)
                                                          ) +
                                                          " · " +
                                                          _vm._s(
                                                            item.product_name
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-history-list__meta",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.formatHistoryDate(
                                                              item.created_at
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                      _vm.getReportUserName(
                                                        item
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                        · " +
                                                                _vm._s(
                                                                  _vm.getReportUserName(
                                                                    item
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              item.product_name !==
                                              "Processing..."
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "report-history-list__score bg-success",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item
                                                              .analysis_content
                                                              ?.score ?? 0
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      !_vm.filteredHistoryList.length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "report-history-list__empty",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  No reports found\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isShared
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { "aria-label": "Add products" },
                          on: { click: _vm.toggleAddProducts },
                        },
                        [
                          _c("i", {
                            staticClass: "bi",
                            class: _vm.isAddProductsExpanded
                              ? "bi-dash"
                              : "bi-plus",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedReport && !_vm.isShared
                    ? _c(
                        "b-dropdown",
                        {
                          attrs: {
                            variant: "light",
                            right: "",
                            "no-caret": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("i", {
                                      staticClass: "bi bi-three-dots",
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2590032983
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.viewProduct(_vm.selectedReport)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-arrow-up-right-square me-2",
                              }),
                              _vm._v(" View Product\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.copyAction("id")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-copy me-2" }),
                              _vm._v(" Copy Product ID\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.copyAction("url")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-link-45deg me-2" }),
                              _vm._v(" Copy URL\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                disabled: _vm.updatingReports.includes(
                                  _vm.selectedReport.id
                                ),
                              },
                              on: { click: _vm.regenerateReport },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-arrow-clockwise me-2",
                              }),
                              _vm._v(" Re-generate Report\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                disabled: _vm.updatingReports.includes(
                                  _vm.selectedReport.id
                                ),
                              },
                              on: { click: _vm.regenerateReportImages },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-arrow-clockwise me-2",
                              }),
                              _vm._v(" Re-generate Images\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isShared
                            ? _c(
                                "b-dropdown-item",
                                { on: { click: _vm.shareReport } },
                                [
                                  _c("i", { staticClass: "bi bi-share me-2" }),
                                  _vm._v(" Share Report\n            "),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("b-dropdown-divider"),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.selectedReport.images?.length,
                              },
                              on: { click: _vm.publishReport },
                            },
                            [
                              _c("i", { staticClass: "bi bi-cloud-upload" }),
                              _vm._v(" Publish...\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-dropdown-divider"),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.xlsxExport(_vm.selectedReport.id)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-download" }),
                              _vm._v(" Export Selected Item\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.xlsxExport()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-file-earmark-excel",
                              }),
                              _vm._v(" Export All Items\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-dropdown-divider"),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.xlsxOptimizationAfterExport(
                                    _vm.selectedReport.id
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-download" }),
                              _vm._v(" Export Optimized Item\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.xlsxOptimizationAfterExport()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-file-earmark-excel",
                              }),
                              _vm._v(
                                " Export All Optimized Items\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-dropdown-divider"),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              staticClass: "text-danger",
                              attrs: {
                                disabled: _vm.updatingReports.includes(
                                  _vm.selectedReport.id
                                ),
                              },
                              on: { click: _vm.deleteReport },
                            },
                            [
                              _c("i", { staticClass: "bi bi-trash me-2" }),
                              _vm._v(" Remove Product\n            "),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-dropdown",
                    {
                      attrs: {
                        variant: "light",
                        right: "",
                        "no-caret": "",
                        "toggle-class": "reports-type-dropdown__toggle",
                        "menu-class": "reports-type-dropdown__menu",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function () {
                              return [_c("i", { staticClass: "bi bi-gear" })]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2662832617
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "reports-type-dropdown__header" },
                        [
                          _c(
                            "div",
                            { staticClass: "reports-type-dropdown__title" },
                            [
                              _vm._v(
                                "\n                Prompt settings\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "reports-type-dropdown__subtitle" },
                            [
                              _vm._v(
                                "\n                Choose which prompt renders each report tab.\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "reports-type-dropdown__tabs" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "reports-type-dropdown__tab",
                              class: {
                                "is-active":
                                  _vm.promptSettingsTab === "title_copy",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.setPromptSettingsTab("title_copy")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                Title + Copy\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "reports-type-dropdown__tab",
                              class: {
                                "is-active": _vm.promptSettingsTab === "images",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.setPromptSettingsTab("images")
                                },
                              },
                            },
                            [_vm._v("\n                Images\n              ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "reports-type-dropdown__current" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "reports-type-dropdown__current-label",
                            },
                            [
                              _vm._v(
                                "\n                Current " +
                                  _vm._s(
                                    _vm.promptSettingsTab === "images"
                                      ? "Images"
                                      : "Title + Copy"
                                  ) +
                                  " prompt\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "reports-type-dropdown__current-value",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.activePromptSettingsOption
                                      ? _vm.activePromptSettingsOption.label
                                      : "Default Prompt"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "reports-type-dropdown__search" },
                        [
                          _c("i", {
                            staticClass:
                              "bi bi-search reports-type-dropdown__search-icon",
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.promptSearchQuery,
                                expression: "promptSearchQuery",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "reports-type-dropdown__search-input",
                            attrs: {
                              type: "text",
                              placeholder: "Search prompts...",
                            },
                            domProps: { value: _vm.promptSearchQuery },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                              keydown: function ($event) {
                                $event.stopPropagation()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.promptSearchQuery =
                                  $event.target.value.trim()
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.promptSearchQuery
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "reports-type-dropdown__search-clear",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Clear prompt search",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.promptSearchQuery = ""
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "bi bi-x" })]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.filteredPromptOptions
                        ? _c(
                            "div",
                            { staticClass: "reports-type-dropdown__list" },
                            _vm._l(
                              _vm.filteredPromptOptions,
                              function (option) {
                                return _c(
                                  "button",
                                  {
                                    key: option.value,
                                    staticClass:
                                      "reports-type-dropdown__option",
                                    class: {
                                      "is-active":
                                        _vm.activePromptSettingsValue ===
                                        option.value,
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectPromptForActiveTab(
                                          option.value
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "reports-type-dropdown__radio",
                                      },
                                      [
                                        _vm.activePromptSettingsValue ===
                                        option.value
                                          ? _c("span", {
                                              staticClass:
                                                "reports-type-dropdown__radio-inner",
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "reports-type-dropdown__content",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "reports-type-dropdown__label",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(option.label) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "reports-type-dropdown__description",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(option.description) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.lightbox.isOpen
                    ? _c(
                        "div",
                        {
                          staticClass: "lightbox",
                          attrs: { tabindex: "-1" },
                          on: {
                            click: function ($event) {
                              if ($event.target !== $event.currentTarget)
                                return null
                              return _vm.closeLightbox.apply(null, arguments)
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape",
                                ])
                              )
                                return null
                              return _vm.closeLightbox.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "lightbox__close",
                              attrs: { type: "button", "aria-label": "Close" },
                              on: { click: _vm.closeLightbox },
                            },
                            [_c("i", { staticClass: "bi bi-x-lg" })]
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "lightbox__img",
                            attrs: { src: _vm.lightbox.src, alt: "" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.lastAnalyzedAt
        ? _c("div", { staticClass: "last-analyzed" }, [
            _c("i", { staticClass: "bi bi-clock-history" }),
            _vm._v(
              "\n      Last analyzed " +
                _vm._s(_vm.formatRelativeTime(_vm.lastAnalyzedAt)) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3 mb-4" }, [
        _c(
          "div",
          {
            staticClass: "prompts-list",
            class: { "items-5": _vm.pdpTabs.length === 5 },
          },
          _vm._l(_vm.pdpTabs, function (prompt) {
            return _c(
              "div",
              {
                key: prompt.id,
                staticClass: "prompt-item",
                class: {
                  active: _vm.selectedPromptId === prompt.id,
                  "iframe-tab": _vm.isIframe,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectPrompt(prompt)
                  },
                },
              },
              [
                _c("div", { staticClass: "prompt-item__title" }, [
                  _c(
                    "div",
                    { staticClass: "icon-wrap" },
                    [
                      prompt.icon_type === "string"
                        ? _c("i", { class: prompt.icon })
                        : _c(prompt.icon, {
                            tag: "component",
                            attrs: { width: "14" },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "prompt-item__title__text" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(prompt.title) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.isAddProductsExpanded && _vm.selectedPromptId !== 4
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [_vm._m(2)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAddProductsExpanded && _vm.selectedPromptId !== 4
        ? _c(
            "section",
            { staticClass: "source-grid mt-3 mb-3" },
            _vm._l(_vm.sources, function (source) {
              return _c(
                "a",
                {
                  key: source.id,
                  class: [
                    "source-card",
                    { "source-card--active": _vm.selectedSource === source.id },
                  ],
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.selectSource($event, source)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "source-card__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("i", { class: source.icon })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "source-card__body" }, [
                    _c("h3", { staticClass: "source-card__title" }, [
                      _vm._v(_vm._s(source.title)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "source-card__desc" }, [
                      _vm._v(_vm._s(source.description)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSource === "asin_urls" &&
      !_vm.selectedReport &&
      _vm.selectedPromptId !== 4
        ? _c("section", { staticClass: "urls-section source-sections mt-3" }, [
            _c("div", { staticClass: "space-y-2" }, [
              _c(
                "div",
                {
                  staticClass: "product-list-section mb-4",
                  staticStyle: {
                    border: "1px solid #e2e8f0",
                    "border-radius": "8px",
                    padding: "12px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "accordion-header d-flex justify-content-between align-items-center",
                      staticStyle: { "user-select": "none" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-sm font-medium",
                          staticStyle: { cursor: "pointer", flex: "1" },
                          on: {
                            click: function ($event) {
                              _vm.isProductListExpanded =
                                !_vm.isProductListExpanded
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Select from Product Lists\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isProductListExpanded &&
                      _vm.availableProducts.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center gap-2 mr-3",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "text-sm",
                                  class: {
                                    "text-muted":
                                      _vm.isLoadingProducts ||
                                      _vm.filteredProducts.length === 0,
                                  },
                                  staticStyle: { "text-decoration": "none" },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      !_vm.isLoadingProducts &&
                                        _vm.filteredProducts.length > 0 &&
                                        _vm.selectAllProducts()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class:
                                      _vm.selectedProducts.length ===
                                        _vm.filteredProducts.length &&
                                      _vm.filteredProducts.length > 0
                                        ? "bi bi-check-square"
                                        : "bi bi-square",
                                  }),
                                  _vm._v(
                                    "\n                Select All\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.productTypeFilter,
                                      expression: "productTypeFilter",
                                    },
                                  ],
                                  staticClass:
                                    "form-select form-select-sm product-select-all",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.productTypeFilter = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.handleTypeFilterChange,
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "all" } }, [
                                    _vm._v(
                                      "\n                  All\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.availableProductTypes,
                                    function (type) {
                                      return _c(
                                        "option",
                                        {
                                          key: type,
                                          domProps: { value: type },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(type) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i", {
                        class: _vm.isProductListExpanded
                          ? "bi bi-chevron-up"
                          : "bi bi-chevron-down",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            _vm.isProductListExpanded =
                              !_vm.isProductListExpanded
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isProductListExpanded,
                          expression: "isProductListExpanded",
                        },
                      ],
                      staticClass: "row mt-2",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-md-6 pr-1" },
                        [
                          _c("Multiselect", {
                            attrs: {
                              options: _vm.productListOptions,
                              multiple: true,
                              searchable: true,
                              loading: _vm.isLoadingProductLists,
                              disabled: _vm.isLoadingProductLists,
                              "track-by": "id",
                              label: "name",
                              placeholder: "Choose product lists...",
                            },
                            on: { input: _vm.loadProductsFromLists },
                            model: {
                              value: _vm.selectedProductLists,
                              callback: function ($$v) {
                                _vm.selectedProductLists = $$v
                              },
                              expression: "selectedProductLists",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.availableProducts.length > 0
                        ? _c(
                            "div",
                            { staticClass: "col-md-6 pl-1" },
                            [
                              _c(
                                "Multiselect",
                                {
                                  attrs: {
                                    options: _vm.filteredProducts,
                                    multiple: true,
                                    searchable: true,
                                    disabled: _vm.isLoadingProducts,
                                    loading: _vm.isLoadingProducts,
                                    "close-on-select": false,
                                    "track-by": "id",
                                    label: "display_name",
                                    placeholder: "Select specific products",
                                    "allow-empty": true,
                                    limit: 3,
                                    "limit-text": _vm.limitText,
                                    "max-height": 300,
                                  },
                                  on: { input: _vm.populateSelectedProducts },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function (props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "multiselect-option",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.option.display_name
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.option
                                                          .product_list_name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2136968834
                                  ),
                                  model: {
                                    value: _vm.selectedProducts,
                                    callback: function ($$v) {
                                      _vm.selectedProducts = $$v
                                    },
                                    expression: "selectedProducts",
                                  },
                                },
                                [
                                  _vm._v(" "),
                                  _c("template", { slot: "noResult" }, [
                                    _vm._v(
                                      "\n                  No products found\n                "
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-2",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 mb-0",
                    },
                    [
                      _vm._v(
                        "\n            Amazon ASINs, Walmart IDs, or Product URLs\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCountry,
                          expression: "selectedCountry",
                        },
                      ],
                      staticClass: "form-control form-control-sm",
                      staticStyle: { "max-width": "220px" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedCountry = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.amazonCountries, function (country) {
                      return _c(
                        "option",
                        {
                          key: country.value,
                          domProps: { value: country.value },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(country.label) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.urls,
                    expression: "urls",
                  },
                ],
                attrs: {
                  placeholder:
                    "Enter one per line: B08XYZ1234, https://www.amazon.com/dp/B08ABC5678",
                },
                domProps: { value: _vm.urls },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.urls = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0" }, [
                _c("div", { staticClass: "col-md-6 pl-0 pr-2" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keywords,
                        expression: "keywords",
                      },
                    ],
                    staticClass: "mt-1",
                    attrs: {
                      id: "used-keywords",
                      placeholder:
                        "Preferred keywords (optional). Separate with commas.",
                    },
                    domProps: { value: _vm.keywords },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.keywords = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 pl-2 pr-0" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.excludedKeywords,
                        expression: "excludedKeywords",
                      },
                    ],
                    staticClass: "mt-1",
                    attrs: {
                      id: "excluded-keywords",
                      placeholder:
                        "Excluded keywords (optional). Separate with commas.",
                    },
                    domProps: { value: _vm.excludedKeywords },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.excludedKeywords = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSource === "spreadsheet" &&
      !_vm.selectedReport &&
      _vm.selectedPromptId !== 4
        ? _c(
            "section",
            { staticClass: "drop-zone source-sections mt-3" },
            [
              _c("Vue2Dropzone", {
                key: "imageUploadDropzone",
                ref: "fileInput",
                class: { "has-files": _vm.uploadedFiles.length > 0 },
                attrs: {
                  id: "imageUploadDropzone",
                  options: _vm.dropzoneOptions,
                },
                on: {
                  "vdropzone-file-added": _vm.onFileAdded,
                  "vdropzone-removed-file": _vm.onFileRemoved,
                },
              }),
              _vm._v(" "),
              _vm.sourceError
                ? _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n        Product ID or ASIN column is required.\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.uploadedFiles.length > 0
                ? _c(
                    "div",
                    { staticClass: "uploaded-files-list mt-3" },
                    _vm._l(_vm.uploadedFiles, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "uploaded-file-item" },
                        [
                          _c("div", { staticClass: "uploaded-file-row" }, [
                            _c("div", { staticClass: "uploaded-file-info" }, [
                              _c("i", {
                                staticClass: "bi bi-upload uploaded-file-icon",
                              }),
                              _vm._v(" "),
                              _c("strong", [_vm._v(_vm._s(item.name))]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "uploaded-file-size" },
                                [_vm._v(_vm._s(_vm.formatFileSize(item.size)))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-close-file",
                                attrs: {
                                  type: "button",
                                  "aria-label": "Remove",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeUploadedFile(item)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-x-lg" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "uploaded-file-save" }, [
                            _c("label", { staticClass: "save-as-list-label" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.saveAsList,
                                    expression: "item.saveAsList",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(item.saveAsList)
                                    ? _vm._i(item.saveAsList, null) > -1
                                    : item.saveAsList,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = item.saveAsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "saveAsList",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "saveAsList",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "saveAsList", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "save-as-list-text" }, [
                                _vm._v("Save as list:"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.listName,
                                  expression: "item.listName",
                                },
                              ],
                              staticClass:
                                "form-control form-control-sm save-as-list-input",
                              attrs: {
                                type: "text",
                                disabled: !item.saveAsList,
                              },
                              domProps: { value: item.listName },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    item,
                                    "listName",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          item.sheetOptions && item.sheetOptions.length > 1
                            ? _c(
                                "div",
                                { staticClass: "uploaded-file-sheet mt-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "uploaded-file-sheet__label",
                                    },
                                    [
                                      _vm._v(
                                        "\n              Sheet:\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.selectedSheetName,
                                          expression: "item.selectedSheetName",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control-sm uploaded-file-sheet__select",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              item,
                                              "selectedSheetName",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function ($event) {
                                            return _vm.handleSpreadsheetSheetChange(
                                              item
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    _vm._l(
                                      item.sheetOptions,
                                      function (sheetName) {
                                        return _c(
                                          "option",
                                          {
                                            key: sheetName,
                                            domProps: { value: sheetName },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(sheetName) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.hasAutoFilter
                            ? _c(
                                "div",
                                { staticClass: "uploaded-file-filter mt-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "uploaded-file-filter__label",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              item.selectAllSpreadsheetRows,
                                            expression:
                                              "item.selectAllSpreadsheetRows",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            item.selectAllSpreadsheetRows
                                          )
                                            ? _vm._i(
                                                item.selectAllSpreadsheetRows,
                                                null
                                              ) > -1
                                            : item.selectAllSpreadsheetRows,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  item.selectAllSpreadsheetRows,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      item,
                                                      "selectAllSpreadsheetRows",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      item,
                                                      "selectAllSpreadsheetRows",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  item,
                                                  "selectAllSpreadsheetRows",
                                                  $$c
                                                )
                                              }
                                            },
                                            function ($event) {
                                              return _vm.handleSpreadsheetSelectAllChange(
                                                item
                                              )
                                            },
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Select all rows")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "uploaded-file-filter__hint",
                                    },
                                    [
                                      _vm._v(
                                        "\n              Off by default: uses only visible / filtered rows.\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSource === "salsify_integration" &&
      !_vm.selectedReport &&
      _vm.selectedPromptId !== 4
        ? _c(
            "section",
            { staticClass: "salsify-integration source-sections mt-3" },
            [
              _vm._m(6),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "section",
                  attrs: { "aria-labelledby": "pull-title" },
                },
                [
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tabs",
                      attrs: {
                        role: "tablist",
                        "aria-label": "Select input method",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "tab",
                          class: { active: _vm.pullMode === "manual" },
                          attrs: {
                            id: "tab-ids",
                            role: "tab",
                            "aria-controls": "pane-ids",
                            "aria-selected": "true",
                          },
                          on: {
                            click: function ($event) {
                              _vm.pullMode = "manual"
                            },
                          },
                        },
                        [_vm._v("\n            Manual IDs\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "tab",
                          class: { active: _vm.pullMode === "product_list" },
                          attrs: {
                            id: "tab-list",
                            role: "tab",
                            "aria-controls": "pane-list",
                            "aria-selected": "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.pullMode = "product_list"
                            },
                          },
                        },
                        [_vm._v("\n            Product List\n          ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tabpanes" }, [
                    _vm.pullMode === "manual"
                      ? _c(
                          "div",
                          {
                            staticClass: "tabpane active",
                            attrs: {
                              id: "pane-ids",
                              role: "tabpanel",
                              "aria-labelledby": "tab-ids",
                            },
                          },
                          [_vm._m(8)]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "tabpane",
                            attrs: {
                              id: "pane-list",
                              role: "tabpanel",
                              "aria-labelledby": "tab-list",
                            },
                          },
                          [_vm._m(9)]
                        ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSource && !_vm.selectedReport && _vm.selectedPromptId !== 4
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-end align-content-end mt-4",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn continue-btn",
                  attrs: { disabled: _vm.isProcessing || _vm.isErrors },
                  on: { click: _vm.prepareReport },
                },
                [
                  !_vm.isProcessing
                    ? _c("span", [_vm._v("Continue to Analysis")])
                    : _c("span", [_vm._v("Processing...")]),
                  _vm._v(" "),
                  _c("i", { staticClass: "bi bi-arrow-right d-flex ml-2" }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.selectedReport && _vm.reportData) || _vm.selectedPromptId === 4
        ? _c("section", { staticClass: "pdp-tab-section" }, [
            _vm.selectedPromptId === 1
              ? _c(
                  "div",
                  [
                    _c("PdpTextCopyTab", {
                      attrs: {
                        "report-data": _vm.reportData,
                        "analysis-content": _vm.titleCopyAnalysisContent,
                        "report-content": _vm.titleCopyReportContent,
                        "selected-prompt-value":
                          _vm.selectedTitleCopyPromptValue,
                        "selected-prompt-label":
                          _vm.selectedTitleCopyPromptOption.label,
                        "is-regenerating":
                          _vm.selectedReport &&
                          _vm.updatingReports.includes(_vm.selectedReport.id),
                      },
                      on: { regenerate: _vm.regenerateReport },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedPromptId === 2
              ? _c(
                  "div",
                  {
                    staticClass: "optimize-report",
                    class: { "shared-locked": _vm.isTabLocked(2) },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "analysis-summary-accordion mb-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "accordion-header",
                            on: { click: _vm.toggleAnalysisSummary },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "accordion-header-content" },
                              [
                                _c("h5", { staticClass: "accordion-title" }, [
                                  _vm._v(
                                    "\n                Analysis Summary\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "bi accordion-icon",
                                  class: _vm.isAnalysisSummaryExpanded
                                    ? "bi-chevron-down"
                                    : "bi-chevron-right",
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isAnalysisSummaryExpanded,
                                expression: "isAnalysisSummaryExpanded",
                              },
                            ],
                            staticClass: "accordion-body",
                          },
                          [
                            _c("div", { staticClass: "score-wrap" }, [
                              _c("div", { staticClass: "score-card" }, [
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("Current Score"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "score" }, [
                                  _c("span", { staticClass: "current" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.reportData?.analysis_content
                                          ?.score || 0
                                      )
                                    ),
                                  ]),
                                  _vm._v(" / "),
                                  _c("span", [_vm._v("100")]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "progress" }, [
                                  _c("div", {
                                    staticClass: "progress-bar bg-success",
                                    style: {
                                      width:
                                        (_vm.reportData?.analysis_content
                                          ?.score ?? 0) + "%",
                                    },
                                    attrs: {
                                      role: "progressbar",
                                      "aria-valuenow":
                                        _vm.reportData?.analysis_content
                                          ?.score ?? 0,
                                      "aria-valuemin": "0",
                                      "aria-valuemax": "100",
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "score-card" }, [
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("Issues Found"),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "issues-count" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.reportData?.analysis_content
                                          ?.issues_found?.total ?? "-"
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "badges-list" }, [
                                  _vm.reportData?.analysis_content?.issues_found
                                    ?.critical
                                    ? _c(
                                        "div",
                                        { staticClass: "badge badge-danger" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.reportData?.analysis_content
                                                  ?.issues_found?.critical
                                              ) +
                                              " Critical\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.reportData?.analysis_content?.issues_found
                                    ?.warning
                                    ? _c(
                                        "div",
                                        { staticClass: "badge badge-warning" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.reportData?.analysis_content
                                                  ?.issues_found?.warning
                                              ) +
                                              " Warning\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.reportData?.analysis_content?.issues_found
                                    ?.info
                                    ? _c(
                                        "div",
                                        { staticClass: "badge badge-info" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.reportData?.analysis_content
                                                  ?.issues_found?.info
                                              ) +
                                              " Info\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "score-card" }, [
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("Potential Gain"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "gains-card" }, [
                                  _c("div", { staticClass: "gains-item" }, [
                                    _c("span", [
                                      _vm._v(
                                        "+ " +
                                          _vm._s(
                                            _vm.reportData?.analysis_content
                                              ?.potential_gain ?? "-"
                                          )
                                      ),
                                    ]),
                                    _vm._v(" points\n                  "),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v("After optimization"),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      ref: "optRoot",
                      staticClass: "opt-root mb-4",
                      domProps: {
                        innerHTML: _vm._s(_vm.reportData.optimize_content),
                      },
                      on: {
                        "!click": function ($event) {
                          return _vm.onRootClick.apply(null, arguments)
                        },
                        input: _vm.onRootInput,
                      },
                    }),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center gap-2 pdp-edit-toolbar",
                          },
                          [
                            _c(
                              "button",
                              {
                                class:
                                  _vm.isEditingKeywords ||
                                  _vm.isEditingExcludedKeywords
                                    ? "btn btn-outline-secondary btn-sm"
                                    : "btn btn-success btn-sm",
                                attrs: { disabled: _vm.isSaving },
                                on: { click: _vm.saveOptimized },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.isSaving ? "Saving..." : "Save"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isEditingKeywords ||
                            _vm.isEditingExcludedKeywords
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success btn-sm",
                                    attrs: { disabled: _vm.isSaving },
                                    on: { click: _vm.saveAndRegenerate },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.isSaving
                                            ? "Saving..."
                                            : "Save & Re-Generate Report"
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-link btn-sm text-muted px-1",
                                attrs: { disabled: _vm.isSaving },
                                on: { click: _vm.cancelEdit },
                              },
                              [_vm._v("\n            Cancel\n          ")]
                            ),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted ms-2" }, [
                              _vm._v(
                                "\n            Editing in progress…\n          "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedPromptId === 3
              ? _c(
                  "div",
                  {
                    staticClass: "kw-rankings",
                    class: { "shared-locked": _vm.isTabLocked(3) },
                  },
                  [
                    _c("div", { staticClass: "kw-card" }, [
                      _c("div", { staticClass: "kw-head" }, [
                        _c("h4", { staticClass: "mb-1" }, [
                          _vm._v(
                            "\n              Keyword Rankings\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n              Current keyword performance comparison\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "button-list mt-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: {
                                click: function ($event) {
                                  _vm.showKeywordForm = !_vm.showKeywordForm
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-plus" }),
                              _vm._v(" Add Keyword\n              "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: { click: _vm.reCrawlKeywords },
                            },
                            [
                              _c("i", { staticClass: "bi bi-arrow-clockwise" }),
                              _vm._v(" Re-run Crawl\n              "),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.showKeywordForm
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "add-form d-flex align-items-center gap-2 mt-3",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newKeyword,
                                      expression: "newKeyword",
                                    },
                                  ],
                                  staticClass: "form-control keyword-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Enter keyword...",
                                  },
                                  domProps: { value: _vm.newKeyword },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.newKeyword = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn add-btn ml-2",
                                    attrs: { type: "button" },
                                    on: { click: _vm.addKeyword },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Add\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "kw-kpis" }, [
                        _c("div", { staticClass: "kpi" }, [
                          _c("div", { staticClass: "kpi-label text-muted" }, [
                            _vm._v(
                              "\n                Keywords Tracked\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "kpi-value" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.reportData?.keywords?.length ?? 0) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "kpi" }, [
                          _c("div", { staticClass: "kpi-label text-muted" }, [
                            _vm._v(
                              "\n                Avg. Rank Before\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "kpi-value" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.reportData?.analysis_content
                                    ?.keyword_rankings?.avg_before ?? 0
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "kpi" }, [
                          _c("div", { staticClass: "kpi-label text-muted" }, [
                            _vm._v(
                              "\n                Avg. Rank After\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "kpi-value text-success" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.reportData?.analysis_content
                                    ?.keyword_rankings?.avg_after ?? 0
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-responsive" }, [
                        _c("table", { staticClass: "table kw-table mb-0" }, [
                          _vm._m(10),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.reportKeywords, function (row, i) {
                              return _c("tr", { key: "kw-" + i }, [
                                _c("td", { staticClass: "kw-text" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(row.keyword) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(row.start_position) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-center text-success fw-semibold",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(row.current_position) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  !isNaN(+row.current_position) &&
                                  Math.max(
                                    0,
                                    (!isNaN(+row.start_position)
                                      ? +row.start_position
                                      : 0) -
                                      (!isNaN(+row.current_position)
                                        ? +row.current_position
                                        : 0)
                                  ) > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "change-pill" },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M7 17L17 7M17 7H9M17 7V15",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                      +" +
                                              _vm._s(
                                                Math.max(
                                                  0,
                                                  (!isNaN(+row.start_position)
                                                    ? +row.start_position
                                                    : 0) -
                                                    (!isNaN(
                                                      +row.current_position
                                                    )
                                                      ? +row.current_position
                                                      : 0)
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : _c("span", [_vm._v("-")]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-end" }, [
                                  _c("i", {
                                    staticClass: "bi bi-trash delete-keyword",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteKeyword(row)
                                      },
                                    },
                                  }),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedPromptId === 4
              ? _c(
                  "div",
                  { class: { "shared-locked": _vm.isTabLocked(4) } },
                  [
                    !_vm.isTabLocked(4)
                      ? _c("ShareOfShelf")
                      : _c("div", { staticClass: "shared-locked-placeholder" }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedPromptId === 5
              ? _c(
                  "div",
                  [
                    _c("ImageAnalysisOverview", {
                      attrs: {
                        images: _vm.selectedReport?.images ?? [],
                        "pdp-report": _vm.reportData,
                        "analysis-content": _vm.imagesAnalysisContent,
                        "report-content": _vm.imagesReportContent,
                        "selected-prompt-value": _vm.selectedImagesPromptValue,
                        "selected-prompt-label":
                          _vm.selectedImagePromptOption.label,
                        "is-regenerating": _vm.updatingReports.includes(
                          _vm.selectedReport.id
                        ),
                        "read-only": _vm.isShared && !_vm.isAuthenticated,
                      },
                      on: { regenerate: _vm.regenerateReportImages },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isTabLocked(_vm.selectedPromptId)
              ? _c("div", { staticClass: "shared-lock-overlay" }, [
                  _c("div", { staticClass: "shared-lock-card" }, [
                    _c("i", {
                      staticClass: "bi bi-lock-fill shared-lock-icon",
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "shared-lock-text mb-3" }, [
                      _vm._v(
                        "\n            This section is only available to logged-in users.\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: _vm.loginUrl },
                      },
                      [
                        _vm._v(
                          "\n            Login to view the full report\n          "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !(_vm.isShared && !_vm.isAuthenticated)
        ? _c("OptixPublishToPlatformModal", {
            attrs: {
              report: _vm.selectedReport,
              "optimized-content": _vm.optimizedContent,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "a",
        {
          staticStyle: {
            "text-decoration": "none",
            "font-size": "1.125rem",
            "font-weight": "600",
            "white-space": "nowrap",
          },
          attrs: {
            href: "https://itsrapid.ai/image-optimization/",
            target: "_blank",
          },
        },
        [
          _c("span", { staticStyle: { color: "#209c86" } }, [_vm._v("It's")]),
          _c("span", { staticStyle: { color: "#000" } }, [_vm._v("Rapid")]),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#209c86" } }, [_vm._v("Optix")]),
          _c("span", { staticStyle: { color: "#6b7280" } }, [_vm._v("™")]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center" },
      [
        _c("div", [
          _c("h5", { staticClass: "font-weight-bold mb-1" }, [
            _vm._v("\n          Product Detail Page Analysis\n        "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted mb-0" }, [
            _vm._v(
              "\n          Analyze and optimize your product descriptions with AI-powered insights and keyword tracking\n        "
            ),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h5", { staticClass: "text-lg font-semibold text-foreground mb-0" }, [
        _vm._v("\n          Add Products\n        "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted font-sm mb-0" }, [
        _c("span", [
          _vm._v(
            "\n            Choose how you want to add products to analyze\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "divider-with-text mb-3" }, [
      _c("span", [_vm._v("OR")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      {
        staticClass: "text-sm font-medium leading-none",
        attrs: { for: "used-keywords" },
      },
      [
        _vm._v("\n              Keywords "),
        _c("span", { staticClass: "text-muted font-weight-normal" }, [
          _vm._v("(optional)"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      {
        staticClass: "text-sm font-medium leading-none",
        attrs: { for: "excluded-keywords" },
      },
      [
        _vm._v("\n              Excluded Keywords "),
        _c("span", { staticClass: "text-muted font-weight-normal" }, [
          _vm._v("(optional)"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "section",
      { staticClass: "section", attrs: { "aria-labelledby": "push-title" } },
      [
        _c("h2", { attrs: { id: "push-title" } }, [
          _c("span", {
            staticClass: "status-dot",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" \n          Push Mode – Webhook\n        "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "lead text-muted" }, [
          _vm._v(
            "\n          Configure Salsify to automatically push product updates to this webhook URL:\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "input-row",
            attrs: { role: "group", "aria-label": "Webhook URL" },
          },
          [
            _c("input", {
              attrs: {
                id: "webhook-url",
                type: "text",
                readonly: "",
                value:
                  "https://id-preview--1b3de5e7-06d8-4843-b250-14349dea299a.rapidads.io/api/salsify-webhook",
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn ghost",
                attrs: {
                  id: "copy-url",
                  type: "button",
                  "aria-label": "Copy URL",
                },
              },
              [_vm._v("\n            Copy\n          ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "mini-note text-muted" }, [
          _vm._v(
            "\n          In Salsify, go to Settings → Webhooks → Add Webhook and paste this URL\n        "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", { attrs: { id: "pull-title" } }, [
      _c("span", {
        staticClass: "status-dot",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" \n          Pull Mode – Fetch from Salsify\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-row" }, [
      _c("label", { attrs: { for: "ids" } }, [_vm._v("Salsify Product IDs")]),
      _vm._v(" "),
      _c("textarea", {
        attrs: {
          id: "ids",
          placeholder:
            "Enter Salsify product IDs (one per line)\n12345\n67890\n24680",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "help text-muted" }, [
        _vm._v(
          "\n                We'll fetch product data from Salsify API\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-row" }, [
      _c("label", { attrs: { for: "product-list" } }, [
        _vm._v("Select Product List"),
      ]),
      _vm._v(" "),
      _c("select", { attrs: { id: "product-list" } }, [
        _c("option", { attrs: { value: "", selected: "", disabled: "" } }, [
          _vm._v(
            "\n                  Choose a product list…\n                "
          ),
        ]),
        _vm._v(" "),
        _c("option", [_vm._v("Q4 2025 Products (24 products)")]),
        _vm._v(" "),
        _c("option", [_vm._v("Summer Collection (18 products)")]),
        _vm._v(" "),
        _c("option", [_vm._v("Best Sellers (32 products)")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "help" }, [
        _vm._v(
          "\n                Products from your saved Salsify lists\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Keyword")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("\n                    Before\n                  "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("\n                    After\n                  "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("\n                    Change\n                  "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [
          _vm._v("\n                    Actions\n                  "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }